import mixpanel from 'mixpanel-browser';
import { getMixpanelToken, isProductionEnv } from '#config';

const token = getMixpanelToken();

mixpanel.init(token, {
  debug: !isProductionEnv(),
  track_pageview: 'full-url',
  persistence: 'localStorage',
});
